import { defineStore } from 'pinia';

import { AccountInfo } from '@/pages/Animals/types';

import { PersonalInfo } from './user';

export interface PersonalChaptersData {
  availableInputValue: string;
  documentInputValue: string;
  genderSelectValue?: number;
  nameInputValue: string;
  numberInputValue: string;
  patronymicInputValue: string;
  periodValue: string;
  periodValueTwo: string;
  privateHouseholdInputValue: string;
  selectValueDocuments?: number;
  seriesInputValue: string;
  surnameInputValue: string;
}
export type PersonalKey = keyof PersonalChaptersData;

export interface PersonalChaptersStore {
  data: PersonalChaptersData;
  accounts: PersonalInfo[];
  hasGeneralAcc: boolean;
  id: string | string[];
}

export const usePersonalChapters = defineStore('personalChapters', {
  state: () => {
    return {
      store: {} as PersonalChaptersStore,
      isOpEdit: false,
    };
  },
  actions: {
    setStore(
      data: PersonalChaptersData,
      accounts: PersonalInfo[],
      hasGeneralAcc: boolean,
      id: string | string[]
    ) {
      this.store.data = data;
      this.store.accounts = accounts;
      this.store.hasGeneralAcc = hasGeneralAcc;
      this.store.id = id;
    },
    addNewAccount(account: PersonalInfo) {
      const accounts = this.store.accounts;
      if (!accounts) return;
      accounts.push({
        ...account,
        id: this.store.accounts.length + 1,
        disable: true,
      });
    },
    updateAccountByCode(accountCode: string, newData: any) {
      const accounts = this.store.accounts;
      if (!accounts.length) return;

      const findAcc = accounts.find(
        (acc: AccountInfo) => acc.dim_personal_account === accountCode
      );

      if (!findAcc) return;

      Object.assign(findAcc, newData);
    },
    getGeneral() {
      return this.store.hasGeneralAcc;
    },
    getStore() {
      const store = { ...this.store };
      this.clearStore();
      return store;
    },
    clearStore() {
      this.store = {};
    },
  },
});
